module.exports = __webpack_public_path__ + "img/3.58ac7699.jpg";